import React, { useEffect } from 'react';
import {
  MODAL_SCHEDULE_CREATE_EDIT, MODAL_SCHEDULE_DETAIL, MODAL_SCHEDULER_INACTIVE_WARNING, MODAL_SCHEDULER_NO_WS_WARNING,
  MODAL_SCHEDULER_OFFLINE_AGENT_WARNING
} from 'store/modals/modals';
import { useDispatch, useSelector } from 'react-redux';
import { getAllUserAgents, setIsCreateSchedule, resetState } from 'store/Schedule/actions';
import { selectIsFetching, selectData, selectSelectedSection } from 'store/Schedule/selectors';
import { selectCurrentWorkspace } from 'store/Faraday/selectors';
import { closeModal, openModal } from 'store/modals/actions';
import selectModal from 'store/modals/selectors';
import CreateEditSchedule from './components/CreateEditSchedule';
import ActionBar from './components/ActionBar';
import NoWsWarning from './components/NoWsWarning';
import { Wrapper } from './styled';
import OfflineAgent from './components/OfflineAgent';
import { getWorkspaces } from 'Screens/Contextualization/Workspaces/actions/Actions';
import SECTIONS from './components/ActionBar/components/SectionSelector/Sections';
import SchedulerDetail from './components/SchedulerDetail';
import InactiveScheduler from './components/InactiveScheduler';

const Schedule = () => {
  const showCreateEditModal = useSelector((state) => selectModal(state, MODAL_SCHEDULE_CREATE_EDIT));
  const dispatch = useDispatch();
  const workspaceSelected = useSelector(selectCurrentWorkspace);
  const data = useSelector((state) => (selectData(state)));
  const isFetching = useSelector((state) => (selectIsFetching(state)));
  const noSchedule = data.rows && (data.rows.length === 0 && !isFetching);
  const showNoWsWarning = useSelector((state) => selectModal(state, MODAL_SCHEDULER_NO_WS_WARNING));
  const showOfflineAgentWarning = useSelector((state) => selectModal(state, MODAL_SCHEDULER_OFFLINE_AGENT_WARNING));
  const selectedSection = useSelector(selectSelectedSection);
  const selectedComponent = SECTIONS.find((e) => e.value === selectedSection)?.component;
  const showDetail = useSelector((state) => selectModal(state, MODAL_SCHEDULE_DETAIL));
  const showInactiveSchedulerWarning = useSelector((state) => selectModal(state, MODAL_SCHEDULER_INACTIVE_WARNING));

  useEffect(() => {
    dispatch(getAllUserAgents());
  }, [dispatch, workspaceSelected]);

  useEffect(() => {
    dispatch(getWorkspaces(false, false));
  }, [dispatch]);

  useEffect(() => () => {
    dispatch(resetState());
    dispatch(closeModal(MODAL_SCHEDULER_NO_WS_WARNING));
    dispatch(closeModal(MODAL_SCHEDULER_OFFLINE_AGENT_WARNING));
  }, [dispatch]);

  const showCreate = () => {
    dispatch(setIsCreateSchedule(true));
    dispatch(openModal(MODAL_SCHEDULE_CREATE_EDIT));
  };

  const showEdit = () => {
    dispatch(setIsCreateSchedule(false));
    dispatch(openModal(MODAL_SCHEDULE_CREATE_EDIT));
  };

  return (
    <>
      { showCreateEditModal ? <CreateEditSchedule /> : null }
      <Wrapper emptySchedule={ noSchedule }>
        <ActionBar toggleModalCreateSchedule={ showCreate } toggleModalEditSchedule={ showEdit } />
        { selectedComponent }
        { showNoWsWarning && <NoWsWarning /> }
        { showOfflineAgentWarning && <OfflineAgent /> }
        { showInactiveSchedulerWarning && <InactiveScheduler /> }
        { showDetail && <SchedulerDetail /> }
      </Wrapper>
    </>
  );
};
export default Schedule;
